<!--
 * @description: 配件信息
 * @param: 
 * @return: 
-->
<template>
	<div class="user-management-container">
		<tabel-panel  
			ref="tabel" :rowTemplate="rowTemplate" api="partsInfo"  
			:condition="conditionData" editType="pop" :autoSearch="true"
			@popConfirmButtonClick="popConfirmButtonClick" :clickRowSelected="false">
			
			<template v-slot:tabelTitleLeft>
				<div>配件信息</div>
			</template>
			<template v-slot:tabelTitleRight>
				<add-button @buttonClick="addPower">新增</add-button>
			</template>
			<template v-slot:condition>
				<text-field
					v-model:value="conditionData.bId" 
					labelText="品牌名称:"
					:clearable="true" type="select"
					:selectRemoteSearchData="selectOuguName"
					class="condition-container-input">
				</text-field>

				<text-field
					v-model:value="conditionData.pId" 
					labelText="产品类别:" 
					ref="selectChild"
					:clearable="true" :type="selectChildData == null ? 'select' : 'selectChild'"
					:selectChildData="selectChildData"
					:selectRemoteSearchData="selectOuguNameProduct"
					class="condition-container-input">
				</text-field>
				
				<text-field
					v-model:value="conditionData.mId" 
					labelText="产品型号:" 
					ref="selectChildMoid"
					:clearable="true" :type="selectChildData == null ? 'select' : 'selectChild'"
					:selectChildData="selectChildMoid"
					:selectRemoteSearchData="selectOuguNameModelSelect"
					class="condition-container-input">
				</text-field>
				
				<text-field
					v-model:value="conditionData.Name" 
					labelText="品牌名称:" 
					class="condition-container-input">
				</text-field>
			</template>
				<template v-slot:oprator="$opData">
							<div class="opration">
									<div class="style-aaa"
					 @click="delSingleUser($opData.data)">删除</div>
								<!-- <del-border
									:useConfirm="true" comfirmMessage="确定删除吗？" 
									comfirmOkText="确定" comfirmCancelText="取消" 
									@buttonClick="delSingleUser($opData.data)"></del-border> -->
							</div>
						</template>
		
		</tabel-panel>
	</div>
</template>

<script>
import { ElMessageBox } from 'element-plus'
	import textField from "@/components/textField.vue"
	import delButton from "@/components/delButton.vue"
	import addButton from "@/components/addButton.vue"
	import updateButton from "@/components/updateButton.vue"
	import tabelPanel from "@/components/tabelPanel.vue"
	import popDialog from "@/components/popDialog.vue"
	import tableApi from "@/api/tabel.js"
	import delBorder from "@/components/delBorder.vue"
	import {
		partsInfoEdit,
		partsDelete
	} from "@/api/index.js"
	import {
		errMsg,
		successMsg
	} from "@/notify/index.js"

	export default {
		name: "partsInfo",
		components: {
			delBorder,
			textField,
			addButton,
			delButton,
			tabelPanel,
			popDialog,
			updateButton
		},
		data() {
			const selectValueFn1 = (v, item) => {
				if (item) {
					return item.BrandId
				}
			}
			const selectRemoteSearchData1 = async () => {
				let source = await tableApi.BrandSelect();
				if (source.code == 0) {
					let data = source.data.list.map(({
						id,
						Name
					}) => {
						return {
							label: Name,
							value: id
						}
					})
					let total = 0;
					return {
						total,
						data
					}
				} else {
					errMsg( source.message)
				}
			}
			
			const selectRemoteSearchData = async (pageSize,currentPageIndex,parms) => {
				if(parms.ProductId == null || parms == null){
					return {
						total:0,
						data:null
					}
				}
				let source = await tableApi.modelSelect({
						ProductCategoryId:parms.ProductId,
					});
				if (source.code == 0) {
					let data = source.data.list.map(({
						id,
						Name
					}) => {
						return {
							label: Name,
							value: id
						}
					})
					let total = 0;
					return {
						total,
						data
					}
				} else {
					errMsg( source.message)
				}
			}
			
			const selectRemoteSearchData2 = async (pageSize,currentPageIndex,parms) => {
				debugger
				//产品select列表
				if(parms.BrandId == null || parms == null){
					return {
						total:0,
						data:null
					}
				}
				let source = await tableApi.ProductSelect({Bid:parms.BrandId});
				if (source.code == 0) {
					let data = source.data.list.map(({
						id,
						Name
					}) => {
						return {
							label: Name,
							value: id
						}
					})
					let total = 0;
					return {
						total,
						data
					}
				} else {
					errMsg(source.message)
				}
			}
			return {
				rowTemplate: [ 
					{
						headerLabel: "品牌",
						dataIndex: "BrandName"
					},{
						headerLabel: "产品类别名称",
						dataIndex: "ProductName"
					},{
						headerLabel: "型号",
						dataIndex: "ModelNoName"
					},{
						headerLabel: "品牌",
						dataIndex: "BrandId",
						editable: true,
						requird: true,
						editType: 'select',
						selectRemoteSearchData:selectRemoteSearchData1,
						selectValueFn:selectValueFn1,
						rules:[{
							required: true,
							message: '请选择品牌名'
						}],
						showInList: false
					},{
						headerLabel: "产品类别名称",
						dataIndex: "ProductId",
						editable: true,
						requird: true,
						editType: 'select',
						selectRemoteSearchData:selectRemoteSearchData2,
						refKey: 'BrandId',
						rules:[{
							required: true,
							message: '请选择产品类别'
						}],
						showInList: false
					},{
						headerLabel: "型号",
						dataIndex: "ModelNoId",
						editable: true,
						editType: 'select',
						selectRemoteSearchData,
						refKey: 'ProductId',
						rules:[{
							required: true,
							message: '请输入型号'
						}],
						showInList: false
					},{
						headerLabel: "名称",
						dataIndex: "Name"
					},{
						headerLabel: "配件名称",
						dataIndex: "Name",
						editable: true,
						requird: true,
						editType: 'text',
						renderToHtml: true
					},{
						headerLabel: "价格",
						dataIndex: "Money",
						editable: true,
						requird: true,
						editType: 'number',
						renderToHtml: true
					},{
						headerLabel: "备注",
						editable: true,
						requird: true,
						editType: "textarea",
						dataIndex: "Appendix",
						rows: 2
					},{
						headerLabel: "操作",
						slot: "oprator",
						width: null
					}],
				conditionData: {
					bId: null ,
					pId: null,
					mId: null,
					Name: ''
				},
				selectChildData: null,
				selectChildMoid: null
			}
		},
		watch:{
   /**
    * @description: 监视一级id，改变二级数据
    * @param {*}
    * @return {*}
    */			
			'conditionData.bId'(newV, oldV){
				this.$refs.selectChild.stringValue=""
				if(newV){
					this.selectOuguNameProduct(newV)
					return
				}
				this.selectChildData = null
			},
			'conditionData.pId'(newV, oldV){
				this.$refs.selectChildMoid.stringValue=""
				if(newV){
					this.selectOuguNameModelSelect(newV)
					return
				}
				this.selectChildMoid = null
			}
		},
		methods: {
   /**
    * @description: 三级联动一级：返回数据
    * @param {*}
    * @return {*}
    */			
			async selectOuguName()  {
				let source = await tableApi.BrandSelect();
				if (source.code == 0) {
					let data = source.data.list.map(({
						id,
						Name
					}) => {
						return {
							label: Name,
							value: id
						}
					})
					let total = 0;
					return {
						total,
						data
					}
				} else {
					errMsg(this, source.message)
				}
   /**
    * @description: 
    * @param {*}
    * @return {*}
    */
   /**
    * @description: 
    * @param {*}
    * @return {*}
    */
			},
   /**
    * @description: 三级联动二级
    * @param {*} Bid---一级选择的id
    * @return {*}
    */			
			async selectOuguNameProduct(Bid)  {
				let source
				if(this.selectChildData == null){
					source = await tableApi.ProductSelect();
				} else {
					source = await tableApi.ProductSelect({Bid});
				}
				
				this.selectChildData = source.data.list
				if (source.code == 0) {
					let data = source.data.list.map(({
						id,
						Name
					}) => {
						return {
							label: Name,
							value: id
						}
					})
					let total = 0;
					return {
						total,
						data
					}
				} else {
					errMsg(this, source.message)
				}
			},
   /**
    * @description: 三级联动三级
    * @param {*} ProductCategoryId---二级选择的id
    * @return {*}
    */			
			async selectOuguNameModelSelect(ProductCategoryId)  {
				let source
				if(this.selectChildMoid == null){
					source = await tableApi.modelSelect();
				} else {
					source = await tableApi.modelSelect({ProductCategoryId});
				}
				this.selectChildMoid = source.data.list
				if (source.code == 0) {
					let data = source.data.list.map(({
						id,
						Name
					}) => {
						return {
							label: Name,
							value: id
						}
					})
					let total = 0;
					return {
						total,
						data
					}
				} else {
					errMsg(this, source.message)
				}
			},
   /**
    * @description: 重新获取列表数据
    * @param {*}
    * @return {*}
    */			
			reloadData() {
				this.$refs.tabel.reloadData()
			},
			//单列表删除 
			delSingleUser({
				row,
				columnIndex,
				$index
			}) {
				let id = row.Id
				ElMessageBox.confirm("确定删除吗？", '提示', {
							confirmButtonText:"确定",
							cancelButtonText: "取消",
							type: 'warning'
						}).then(() => {
							partsDelete({id}).then(data => {
					if (data.code == 0) {
						successMsg(data.message)
						this.reloadData()
					} else {
						errMsg( dayta.message)
					}
				})
						}).catch(() => {})
				
			},
			//弹层事件--确认事件
			popConfirmButtonClick({
				slotData
			}) {
				if (slotData.Id === null) {
					// 添加
					let {Appendix, Money ,Name } = slotData
					let mId = slotData.ModelNoId
					partsInfoEdit({mId, Appendix, Money ,Name }).then(data => {
						if (data.code == 0) {
							successMsg(data.message)
							this.reloadData()
							this.$refs.tabel.closeDialog()
						} else {
							errMsg(data.message)
						}
					})
				} else{
					//修改
					slotData.mId = parseInt(slotData.ModelNoId)
					let {Name, mId, Money ,Appendix ,Id} = slotData
					console.log(slotData)
					partsInfoEdit({Name, mId, Money ,Appendix ,Id}).then(data => {
						if (data.code == 0) {
							successMsg(data.message)
							this.reloadData()
							this.$refs.tabel.closeDialog()
						} else {
							errMsg(data.message)
						}
					})
				}
			},
			addPower() {
				this.$refs.tabel.showDialog()
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	@import "~@/assets/styles/_handle.scss";

	#suerSwitch .el-switch__core{
		width: 26px;
	}
	
	.user-management-container {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		overflow: hidden;
		align-items: center;
		align-content: center;
		@include background_color("user-management-bg-color");

		.del {
			margin-left: 10px;
		}

		.condition-container-input {
			width: 270px;
		}

		.opration {
			height: 100%;
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			align-content: center;

			.item {
				&:nth-child(n+1) {
					margin-left: 10px;
				}
			}
		}
		.menuPowerBtn{
			// color:rgb(255, 255, 255)!important;
			// background:rgb(100,134,232)!important;
		}
		.menuPowerBOX{
			.el-button--default{
				width:90px;
				height:30px;
				color: #ffffff;
				background: rgb(100,134,232);
				border-radius: 4px;
			}
			.item {
				height: 30px;
				color: #ffffff !important;
				padding:10px 15px !important;
				background: rgb(100,134,232) !important; 
			}
		}
		.oprationTree{
			height: 300px;
			overflow: auto;
		}
		
	}
	.style-aaa{
	cursor:pointer;
	color:rgb(100,134,232);
	// style="{cursor:'pointer',color:'rgb(100,134,232)'}"
}
</style>
